<template>
  <span :class="badgeClasses">
    <slot />
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue'

type ColorVariant = 'info' | 'black' | 'success' | 'warning' | 'danger'

interface Props {
  variant?: ColorVariant
  customClass?: string
}

const props = withDefaults(defineProps<Props>(), {
  variant: 'black',
})

const badgeClasses = computed(() => {
  const baseClasses = 'relative inline-flex items-center px-2 py-0.5 rounded text-xs font-medium whitespace-nowrap flex-shrink-0 cursor-default'
  const colorClass = `badge--${props.variant}`

  const classes = [baseClasses, colorClass]

  if (props.customClass) {
    classes.push(props.customClass)
  }

  return classes.join(' ')
})
</script>

<style lang="scss" scoped>
@import '@/styles/utils';

.badge--info {
  color: rgb($badge-info-fg);
  background-color: rgb($badge-info-bg);
}

.badge--black {
  color: rgb($badge-neutral-fg);
  background-color: rgb($badge-neutral-bg);
}

.badge--success {
  color: rgb($badge-success-fg);
  background-color: rgb($badge-success-bg);
}

.badge--warning {
  color: rgb($badge-warning-fg);
  background-color: rgb($badge-warning-bg);
}

.badge--danger {
  color: rgb($badge-danger-fg);
  background-color: rgb($badge-danger-bg);
}
</style>
